import { PERMISSION } from '@/constants/permission.constant';

const Add = () => import('@/views/widget/Add.vue');

export const widgetRoute = [
  {
    path: '/widget/edit',
    name: 'widget-edit',
    component: Add,
    meta: { requiresAuth: false, permissions: [PERMISSION.WIDGET_READ] },
  },
];
